import React, { useRef } from 'react'
import { useTranslation } from 'react-i18next'

import { Button } from 'primereact/button'
import { Menu } from 'primereact/menu'

import { PanelContainer } from '../../../../components/Panel'
import { DeliveryForecastDespatchAdvicePackaging } from '../../../../data/models'
import { getConfigTranslation } from '../../../../utils/helper/getConfigTranslation'
import { DefaultConfig } from '../../../ui-config/data'
import { NoPackagingMessage } from './NoPackagingMessage'
import { PackagingTable } from './PackagingTable'
import { DeletePackagingTableData } from './dialogs/DeletePackagingTable'

type Props = {
  despatchAdviceId: string
  itemId?: string
  id?: string
  config: DefaultConfig
  packaging?: DeliveryForecastDespatchAdvicePackaging
  createPackagingTable: (
    despatchAdviceId: string,
    itemId: string,
  ) => Promise<void>
  isRequestRunning: boolean
  isLoading: boolean
}
export const ShippingDetailsView: React.FC<Props> = ({
  despatchAdviceId,
  itemId,
  id,
  config,
  packaging,
  createPackagingTable,
  isRequestRunning,
  isLoading,
}) => {
  const { t } = useTranslation()
  const menuRef = useRef<Menu>(null)

  const hasPackaging = packaging && Object.keys(packaging).length > 0
  const items = [
    {
      label: t(
        'deliveryForecastDespatchAdvice.shippingDetails.add.items.manual',
      ),
      command: () => createPackagingTable(despatchAdviceId, itemId!),
    },
    {
      label: t(
        'deliveryForecastDespatchAdvice.shippingDetails.add.items.automatic',
      ),
      command: () => {},
      disabled: true,
    },
  ]

  const packagingButtons =
    hasPackaging && itemId && id ? (
      <DeletePackagingTableData
        despatchAdviceId={despatchAdviceId}
        itemId={itemId}
        id={id}
      />
    ) : (
      <>
        <Button
          label={t('deliveryForecastDespatchAdvice.shippingDetails.add.label')}
          icon="pi pi-plus"
          onClick={event => menuRef.current?.toggle(event)}
          visible={config.deliveryForecast.addSplitItem.enabled !== false}
          loading={isRequestRunning}
          aria-controls="add_packaging_table"
          aria-haspopup
          disabled={isLoading}
        />
        <Menu
          model={items}
          popup
          ref={menuRef}
          id="add_packaging_table"
          className="bg-white"
        />
      </>
    )

  return (
    <PanelContainer
      header={getConfigTranslation(
        config.deliveryForecastDespatchAdvice.shippingDetails.title,
      )}
      id="delivery-forecast-despatch-advice-shipping-details"
      visible={config.deliveryForecastDespatchAdvice.shippingDetails.enabled}
      buttons={packagingButtons}
    >
      {hasPackaging ? (
        <PackagingTable
          despatchAdviceId={despatchAdviceId}
          itemId={itemId!}
          packagingId={packaging.Id}
        />
      ) : (
        <NoPackagingMessage />
      )}
    </PanelContainer>
  )
}
